import { useDispatch, useSelector } from 'react-redux';
import { setShowOnlyErrors } from '../../../context/errorFilterReducer';

const ErrorFilterButton = () => {
    const dispatch = useDispatch();
    const showOnlyErrors = useSelector(state => state.errorFilter);
    const error = useSelector(state => state.error);
    if (!error && !showOnlyErrors) return null;

    return (
        <button
            className="btn btn-outline-danger mb-2"
            style={{
                marginBottom: '0px !important',
                width: '100px',
                height: '130px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            onClick={() => dispatch(setShowOnlyErrors(!showOnlyErrors))}
        >
            <span style={{ fontSize: '1.5em' }} role="img" aria-label="filter">🔍</span>
            {showOnlyErrors ? 'הצג הכל' : 'הצג רק שורות שגויות'}
        </button>
    );
}
export default ErrorFilterButton;
